import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import { UserRole } from '../models/general.models';
import RouteAuthorizer from './components/RouteAuthorizer';
import { AppRoutes } from './routes';
var ExplorePage = React.lazy(function () { return import('../pages/explore/explore.page'); });
var ExploreCategoryDetailPage = React.lazy(function () { return import('../pages/exploreCategoryDetail/exploreCategoryDetail.page'); });
var exploreRedirectPages = [
    {
        userRole: UserRole.Anonymous,
        page: AppRoutes.Intro,
    },
    {
        userRole: UserRole.NoCountryUser,
        page: AppRoutes.Intro,
    },
    {
        userRole: UserRole.PartialUser,
        page: AppRoutes.JoinFamily,
    },
    {
        userRole: UserRole.UserPaymentNeeded,
        page: AppRoutes.SubscriptionPage,
    },
    {
        userRole: UserRole.PlanPendingUser,
        page: AppRoutes.OnboardingWelcomePage,
    },
];
var exploreRoutes = [
    {
        path: AppRoutes.Explore,
        element: (_jsx(RouteAuthorizer, { userRoles: [UserRole.CompleteUser], redirectPages: exploreRedirectPages, children: _jsx(ExplorePage, {}) })),
    },
    {
        path: "".concat(AppRoutes.Explore, "/:category"),
        element: (_jsx(RouteAuthorizer, { userRoles: [UserRole.CompleteUser], redirectPages: exploreRedirectPages, children: _jsx(ExploreCategoryDetailPage, {}) })),
    },
    {
        path: "".concat(AppRoutes.Explore, "/:category/:id"),
        element: (_jsx(RouteAuthorizer, { userRoles: [UserRole.CompleteUser], redirectPages: exploreRedirectPages, children: _jsx(ExploreCategoryDetailPage, {}) })),
    },
];
export default exploreRoutes;
